var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$route.name === "default"
    ? _c(
        "div",
        {
          staticClass: "default-container theme",
          class: [
            _vm.themeColorClass,
            {
              "theme-rtl theme-rtl-overlap": _vm.isRtl,
              "has-promotion-bar":
                _vm.usePromotionBar &&
                _vm.customSetting.showPromotionHeader &&
                _vm.isPromotionBarActive,
              transparent: _vm.isTransparent,
            },
          ],
        },
        [
          _vm.usePromotionBar && _vm.customSetting.showPromotionHeader
            ? _c("promotion-bar")
            : _vm._e(),
          _vm._v(" "),
          _vm.isSomethingWrong
            ? _c("div", { staticClass: "full-center error-wrapper" }, [
                _c(
                  "figure",
                  {
                    ref: "isSomethingWrong",
                    staticClass: "error-wrapper-container",
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.noPanoramasImage, alt: "no panoramas" },
                    }),
                    _vm._v(" "),
                    _c("figcaption", {
                      domProps: { innerHTML: _vm._s(_vm.$t("somethingWrong")) },
                    }),
                  ]
                ),
              ])
            : !_vm.isExpired &&
              _vm.isBuildingNotFound &&
              _vm.property.objectId &&
              _vm.property.buildings.length
            ? _c("div", { staticClass: "full-center error-wrapper" }, [
                _c(
                  "figure",
                  {
                    ref: "buildingNotInProperty",
                    staticClass: "error-wrapper-container",
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.noPanoramasImage, alt: "no panoramas" },
                    }),
                    _vm._v(" "),
                    _c("figcaption", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("buildingNotInPropertyRedirect")
                        ),
                      },
                    }),
                  ]
                ),
              ])
            : !_vm.isExpired && _vm.isPropertyNotFound
            ? _c("div", { staticClass: "full-center error-wrapper" }, [
                _c(
                  "figure",
                  {
                    ref: "buildingNotFound",
                    staticClass: "error-wrapper-container",
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.noPanoramasImage, alt: "no panoramas" },
                    }),
                    _vm._v(" "),
                    _c("figcaption", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("buildingNotFound")),
                      },
                    }),
                  ]
                ),
              ])
            : _vm.isExpired || _vm.isBuildingNotFound
            ? _c("div", { staticClass: "full-center error-wrapper" }, [
                _c(
                  "figure",
                  {
                    ref: "buildingNotFound",
                    staticClass: "error-wrapper-container",
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.noPanoramasImage, alt: "no panoramas" },
                    }),
                    _vm._v(" "),
                    _c("figcaption", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t(_vm.getNotFoundBuildingText)),
                      },
                    }),
                  ]
                ),
              ])
            : _vm.isAppReady
            ? [
                _c("i-header"),
                _vm._v(" "),
                _c("i-main"),
                _vm._v(" "),
                _c("i-aside"),
                _vm._v(" "),
                _c("i-footer"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("loading"),
          _vm._v(" "),
          _c("i-alert", { attrs: { position: "top-right" } }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }